import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { isDefined, resolveBackgroundColor, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as Checkmark } from '../../../../../resources/assets/components/DLS_CheckmarkStandAlone.svg';
import { Link } from '../../../link/link.js';
import '../color-picker.css';
function ColorPalette(props) {
    const [expanded, setExpanded] = useState(false);
    const middleRow = Math.round(Object.values(props.values)[0].length / 2);
    const [previewRow, setPreviewRow] = useState(middleRow);
    const shouldCollapse = useMemo(() => {
        return Object.values(props.values).some(value => value.length > 1);
    }, [props.values]);
    useEffect(() => {
        if (!isDefined(props.selected)) {
            return;
        }
        for (const value of Object.values(props.values)) {
            const selectedValueRow = value.findIndex(item => item.color === props.selected);
            if (selectedValueRow !== -1) {
                setPreviewRow(selectedValueRow);
                break;
            }
        }
    }, [props.selected, props.values]);
    return (React.createElement(Fragment, null,
        React.createElement("div", { className: "c-color-picker__colors" }, Object.entries(props.values).map(([key, value]) => (React.createElement("div", { key: key }, value.map((item, index) => {
            if (shouldCollapse && !expanded && index !== previewRow) {
                return null;
            }
            return (React.createElement("div", { className: `c-color-picker__color c-color-picker__color-${item.color}`, key: item.color, onClick: trigger(props.onClick, item.color), onMouseEnter: trigger(props.onMouseOver, key, item.shade), onMouseLeave: trigger(props.onMouseOver, ''), style: resolveBackgroundColor(item.color) }, item.color === props.selected
                ? React.createElement(Checkmark, null)
                : null));
        }))))),
        shouldCollapse ? (React.createElement(Link, { className: "c-color-picker__colors-expander", onClick: trigger(setExpanded, !expanded), value: expanded ? 'tws.color-picker.hide-colors' : 'tws.color-picker.show-colors' })) : null));
}
export { ColorPalette, };
//# sourceMappingURL=color-palette.js.map